import { useEffect, useState } from 'react';
import { Grid, Link } from '@mui/material';
import { Title } from '../../components/title/title.component';

import "./subscribe-plans.styles.scss";
import { getMonths } from '../../utils/getData';
import { getCookie, setCookie, useBreakpoints } from '../../utils/generaFunctions'
import Card from '../../components/card/card.page';
import $ from "jquery";

export const SubscribePlans = () =>{
    //Query string variables
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const weddingDate = urlParams.has('weddingDate') ? urlParams.get('weddingDate') : "";
    const weddingDateObj = new Date(weddingDate);
    const weddingDateAfterMonth = new Date(weddingDateObj.setMonth(weddingDateObj.getMonth()+1));
    const gift = urlParams.has('gift') ? urlParams.get('gift') : "";
    const plan = urlParams.has('choice') ? urlParams.get('choice') : "";
    const bonus = window.sessionStorage.getItem("bonus") || getCookie("bonus") || urlParams.get("bonus") || "";
    const month = weddingDate? getMonths()[weddingDateAfterMonth.getMonth()].short:"";
    const {isXl, isXxl} = useBreakpoints();

    const [choice, setChoice] = useState();
    const [hideShown, setHideShown] = useState(false);
    const [hideSweatShirt, setHideSweatShirt] = useState(!bonus.includes("sweatshirt"));
    const [hide, setHide] = useState(false)
    const [noGreyOut, setNoGreyOut] = useState("");
    const [title] = useState(weddingDate?`Curated for weddings up to ${month} ${weddingDateAfterMonth.getFullYear()}`:
                            gift?`Select box delivery frequency`:`No date yet? That’s totally fine!`);
    const [subTitle] = useState(weddingDate?"Based on the wedding date, this is the most suitable plan to get all the themes at the best time during the engagement journey.":
                            "Start today with the “Let’s Plan This” theme & we’ll remind you in a few months to update the date.");
    const [planTexts, setPlanTexts] = useState([{}]);
    const [recommendYear, setRecommendYear] = useState(["","",""]);
    const [ready, setReady] = useState(false);

    useEffect(()=>{
        let now = new Date();
        let year = now.getFullYear();
        let month = now.getMonth();
        if(month < 5){
            setRecommendYear([year, `${year}-${year+1}`,`${year+1}+`,]);
        }else if(month < 10){
            setRecommendYear([`${year}-${year+1}`, `${year+1}-${year+2}`,`${year+2}+`,]);
        } else{
            setRecommendYear([`${year+1}`, `${year+2}`,`${year+3}+`,]);
        }
        setTimeout(()=>{setReady(true)},300);
     },[])

    useEffect(()=>{
        function planTextSelector(plan_code){
            let No3BoxList = ["1-1", "3-6"];
            let returnArr = [];
            if(plan_code === "1-1"){
                returnArr.push({
                    title: "EVERY 2 WEEKS PLAN",
                    code: "mtm-4mo-a",
                    show: true,
                    details: [
                        "Get more themes! It’s ok to be Extra AF",
                        "Themes aligned for a 1-3 months timeline",
                        "Automatically stops after the wedding"
                    ]
                });
                returnArr.push({
                    title: "MONTHLY PLAN",
                    code: "mtm-3mo-s",
                    details: [
                        "Themes aligned for a 1-3 months timeline",
                        "Celebrate every month until the big day",
                        "Automatically stops after the wedding"
                    ]
                });
            } else if(plan_code === "1-2"){
                returnArr.push({
                    title: "EVERY 2 WEEKS PLAN",
                    code: "mtm-4mo-a",
                    show: true,
                    details: [
                        "Get more themes! It’s ok to be Extra AF",
                        "Themes aligned for a 2-4 months timeline",
                        "Automatically stops after the wedding"
                    ]
                });
                returnArr.push({
                    title: "MONTHLY PLAN",
                    code: "mtm-3mo-s",
                    details: [
                        "Themes aligned for a 2-4 months timeline",
                        "Celebrate every month until the big day",
                        "Automatically stops after the wedding"
                    ]
                });
            } else if(plan_code === "1-3"){
                returnArr.push({
                    title: "EVERY 2 WEEKS PLAN",
                    code: "mtm-5mo-a",
                    show: true,
                    details: [
                        "Get more themes! It’s ok to be Extra AF",
                        "Themes aligned for a 2-5 months timeline",
                        "Automatically stops after the wedding"
                    ]
                });
                returnArr.push({
                    title: "MONTHLY PLAN",
                    code: "mtm-3mo-s",
                    details: [
                        "Themes aligned for a 2-5 months timeline",
                        "Celebrate every month until the big day",
                        "Automatically stops after the wedding"
                    ]
                });
            } else if(plan_code === "1-5"){
                returnArr.push({
                    title: "MONTHLY PLAN",
                    code: "mtm-4mo-s",
                    show: true,
                    details: [
                        "Themes aligned for a 2-5 months timeline",
                        "Celebrate every month until the big day",
                        "Automatically stops after the wedding"
                    ]
                });
                returnArr.push({
                    title: "EVERY 2 WEEKS PLAN",
                    code: "mtm-8mo-a",
                    details: [
                        "Get more themes! It’s ok to be Extra AF",
                        "Themes aligned for a 2-5 months timeline",
                        "Automatically stops after the wedding"
                    ]
                });
            } else if(plan_code === "2-2"){
                returnArr.push({
                    title: "MONTHLY PLAN",
                    code: "mtm-5mo-s",
                    show: true,
                    details: [
                        "Themes aligned for a 3-6 months timeline",
                        "Celebrate every month until the big day",
                        "Automatically stops after the wedding"
                    ]
                });
                returnArr.push({
                    title: "EVERY 2 WEEKS PLAN",
                    code: "mtm-8mo-a",
                    details: [
                        "Get more themes! It’s ok to be Extra AF",
                        "Themes aligned for a 3-6 months timeline",
                        "Automatically stops after the wedding"
                    ]
                });
                returnArr.push({
                    title: "EVERY 2 MONTHS PLAN",
                    code: "mtm-4mo-e",
                    details: [
                        "Themes aligned for a 3-6 months timeline",
                        "Accelerates to monthly near the big day",
                        "Automatically stops after the wedding"
                    ]
                });
            } else if(plan_code === "2-3"){
                returnArr.push({
                    title: "MONTHLY PLAN",
                    code: "mtm-6mo-s",
                    show: true,
                    details: [
                        "Themes aligned for a 4-7 months timeline",
                        "Celebrate every month until the big day",
                        "Automatically stops after the wedding"
                    ]
                });
                returnArr.push({
                    title: "EVERY 2 WEEKS PLAN",
                    code: "mtm-10mo-a",
                    details: [
                        "Get all themes! It’s ok to be Extra AF",
                        "Themes aligned for a 4-7 months timeline",
                        "Automatically stops after the wedding"
                    ]
                });
                returnArr.push({
                    title: "EVERY 2 MONTHS PLAN",
                    code: "mtm-5mo-e",
                    details: [
                        "Themes aligned for a 4-7 months timeline",
                        "Accelerates to monthly near the big day",
                        "Automatically stops after the wedding"
                    ]
                });
            } else if(plan_code === "2-4"){
                returnArr.push({
                    title: "MONTHLY PLAN",
                    code: "mtm-7mo-s",
                    show: true,
                    details: [
                        "Themes aligned for a 5-8 months timeline",
                        "Celebrate every month until the big day",
                        "Automatically stops after the wedding"
                    ]
                });
                returnArr.push({
                    title: "EVERY 2 WEEKS PLAN",
                    code: "mtm-10mo-a",
                    show: true,
                    details: [
                        "Get all themes! It’s ok to be Extra AF",
                        "Themes aligned for a 5-8 months timeline",
                        "Automatically stops after the wedding"
                    ]
                });
                returnArr.push({
                    title: "EVERY 2 MONTHS PLAN",
                    code: "mtm-6mo-e",
                    details: [
                        "Themes aligned for a 5-8 months timeline",
                        "Accelerates to monthly near the big day",
                        "Automatically stops after the wedding"
                    ]
                });
            } else if(plan_code === "3-1"){
                returnArr.push({
                    title: "MONTHLY PLAN",
                    code: "mtm-8mo-s",
                    show: true,
                    details: [
                        "Themes aligned for a 6-10 months timeline",
                        "Celebrate every month until the big day",
                        "Automatically stops after the wedding"
                    ]
                });
                returnArr.push({
                    title: "EVERY 2 WEEKS PLAN",
                    code: "mtm-10mo-a",
                    details: [
                        "Get all themes! It’s ok to be Extra AF",
                        "Themes aligned for a 6-10 months timeline",
                        "Automatically stops after the wedding"
                    ]
                });
                returnArr.push({
                    title: "EVERY 2 MONTHS PLAN",
                    code: "mtm-6mo-e",
                    details: [
                        "Themes aligned for a 6-10 months timeline",
                        "Accelerates to monthly near the big day",
                        "Automatically stops after the wedding"
                    ]
                });
            } else if(plan_code === "3-2"){
                returnArr.push({
                    title: "MONTHLY PLAN",
                    code: "mtm-9mo-s",
                    show: true,
                    details: [
                        "Themes aligned for a 6-10 months timeline",
                        "Celebrate every month until the big day",
                        "Automatically stops after the wedding"
                    ]
                });
                returnArr.push({
                    title: "EVERY 2 MONTHS PLAN",
                    code: "mtm-7mo-e",
                    details: [
                        "Themes aligned for a 6-10 months timeline",
                        "Accelerates to monthly near the big day",
                        "Automatically stops after the wedding"
                    ]
                });
            } else if(plan_code === "3-3"){
                returnArr.push({
                    title: "MONTHLY PLAN",
                    code: "mtm-10mo-s",
                    show: true,
                    details: [
                        "Themes aligned for a 8-12 months timeline",
                        "Celebrate every month until the big day",
                        "Automatically stops after the wedding"
                    ]
                });
                returnArr.push({
                    title: "EVERY 2 MONTHS PLAN",
                    code: "mtm-8mo-e",
                    details: [
                        "Themes aligned for a 8-12 months timeline",
                        "Accelerates to monthly near the big day",
                        "Automatically stops after the wedding"
                    ]
                });
            } else if(plan_code === "3-4"){
                returnArr.push({
                    title: "EVERY 2 MONTHS PLAN",
                    code: "mtm-10mo-e",
                    show: true,
                    details: [
                        "Themes aligned for a 12+ months timeline",
                        "Accelerates to monthly near the big day",
                        "Automatically stops after the wedding"
                    ]
                });
                returnArr.push({
                    title: "EVERY 3 MONTHS PLAN",
                    code: "mtm-10mo-q",
                    details: [
                        "Themes aligned for a 12+ months timeline",
                        "Accelerates to monthly near the big day",
                        "Automatically stops after the wedding"
                    ]
                });
                returnArr.push({
                    title: "MONTHLY PLAN",
                    code: "mtm-10mo-s",
                    details: [
                        "Themes aligned for a 12+ months timeline",
                        "Celebrate every month until the big day",
                        "Automatically stops after the wedding"
                    ]
                });
            } else if(plan_code === "3-5"){
                returnArr.push({
                    title: "EVERY 3 MONTHS PLAN",
                    code: "mtm-10mo-q",
                    show: true,
                    details: [
                        "Themes aligned for a 17+ months timeline",
                        "Accelerates to monthly near the big day",
                        "Automatically stops after the wedding"
                    ]
                });
                returnArr.push({
                    title: "EVERY 2 MONTHS PLAN",
                    code: "mtm-10mo-e",
                    details: [
                        "Themes aligned for a 17+ months timeline",
                        "Accelerates to monthly near the big day",
                        "Automatically stops after the wedding"
                    ]
                });
                returnArr.push({
                    title: "MONTHLY PLAN",
                    code: "mtm-10mo-s",
                    details: [
                        "Themes aligned for a 17+ months timeline",
                        "Celebrate every month until the big day",
                        "Automatically stops after the wedding"
                    ]
                });
            } else if(plan_code === "3-6"){
                if(gift){
                    returnArr.push({
                        title: "MONTHLY PLAN",
                        code: "mtm-10mo-s",
                        details: [
                            `Best for weddings likely to be in ${recommendYear[0]}`,
                            "Celebrate every month until the big day",
                            "Automatically stops after the wedding"
                        ],
                        customButtons:[
                            {label:"all themes - 10 boxes", link:"/checkout/?plan=mtm-10mo-s"},
                            {label:"essentials - 7 boxes", link:"/checkout/?plan=mtm-7mo-s"},
                            {label:"intro - 4 boxes", link:"/checkout/?plan=mtm-4mo-si"}
                        ]
                    });
                    returnArr.push({
                        title: "EVERY 2 MONTHS PLAN",
                        code: "mtm-10mo-e",
                        details: [
                            `Best for weddings likely to be in ${recommendYear[1]}`,
                            "Accelerates to monthly near the big day",
                            "Automatically stops after the wedding"
                        ],
                        customButtons:[
                            {label:"all themes - 10 boxes", link:"/checkout/?plan=mtm-10mo-e"},
                            {label:"essentials - 7 boxes", link:"/checkout/?plan=mtm-7mo-e"},
                            {label:"intro - 4 boxes", link:"/checkout/?plan=mtm-4mo-ei"}
                        ]
                    });
                    returnArr.push({
                        title: "EVERY 3 MONTHS PLAN",
                        code: "mtm-10mo-q",
                        details: [
                            `Best for weddings likely to be in ${recommendYear[2]}`,
                            "Accelerates to monthly near the big day",
                            "Automatically stops after the wedding"
                        ],
                        customButtons:[
                            {label:"all themes - 10 boxes", link:"/checkout/?plan=mtm-10mo-q"},
                            {label:"essentials - 7 boxes", link:"/checkout/?plan=mtm-7mo-q"},
                            {label:"intro - 4 boxes", link:"/checkout/?plan=mtm-4mo-qi"}
                        ]
                    });
                } else {
                    returnArr.push({
                        title: "MONTHLY PLAN",
                        code: "mtm-10mo-s",
                        details: [
                            `Best for weddings likely to be in ${recommendYear[0]}`,
                            "Celebrate every month until the big day",
                            "Automatically stops after the wedding"
                        ]
                    });
                    returnArr.push({
                        title: "EVERY 2 MONTHS PLAN",
                        code: "mtm-10mo-e",
                        details: [
                            `Best for weddings likely to be in ${recommendYear[1]}`,
                            "Accelerates to monthly near the big day",
                            "Automatically stops after the wedding"
                        ]
                    });
                    returnArr.push({
                        title: "EVERY 3 MONTHS PLAN",
                        code: "mtm-10mo-q",
                        details: [
                            `Best for weddings likely to be in ${recommendYear[2]}`,
                            "Accelerates to monthly near the big day",
                            "Automatically stops after the wedding"
                        ]
                    });
                }
            }
           if(!No3BoxList.includes(plan_code)){
                returnArr.push({
                    title: "INTRO 3 BOX PLAN",
                    code: "mtm-3mo-si",
                    details: [
                        "To start planning a wedding",
                        "Get boxes monthly",
                        "Automatically stops after the 3rd box"
                    ]
                });
            }
            return returnArr;
        }
        setPlanTexts(planTextSelector(plan));
    },[gift, plan, recommendYear]);

    useEffect(()=>{
        if(planTexts[0].show === true){
            setHide(true);
            // Because of Tilda header
            setTimeout(()=>{setChoice(1);},500);
        }
    },[planTexts]);

    useEffect(()=>{
        if(hideShown){
            document.querySelectorAll(".card.hidden").forEach((hiddenCard)=>{
                hiddenCard.classList.remove('hidden');
                hiddenCard.classList.add('unhidden');
                setNoGreyOut("yes");
            })
            document.querySelectorAll(".card-box.hidden").forEach((hiddenCard)=>{
                hiddenCard.classList.remove('hidden');
                hiddenCard.classList.add('unhidden');
                setNoGreyOut("yes");
            })
        }else {
            document.querySelectorAll(".card.unhidden").forEach((hiddenCard)=>{
                hiddenCard.classList.remove('unhidden');
                hiddenCard.classList.add('hidden');
                setChoice(1);
            })
            document.querySelectorAll(".card-box.unhidden").forEach((hiddenCard)=>{
                hiddenCard.classList.remove('unhidden');
                hiddenCard.classList.add('hidden');
            })
        }
    },[hideShown])

    useEffect(()=>{
        setNoGreyOut("");
        var promo = window.sessionStorage.getItem("promo") || getCookie("promo") || urlParams.get("promo");
        var bonus = window.sessionStorage.getItem("bonus") || getCookie("bonus") || urlParams.get("bonus");
        if(choice>0){
            let planMonth = planTexts[choice-1].code.match(/(\d+)/)&&planTexts[choice-1].code.match(/(\d+)/)[0];
            let planValid4Bonus = (planMonth >= 6);
            if(!planValid4Bonus && promo && promo!=="none") {
                $('#t-header').show(); 
                if(bonus?.includes('sweatshirt')){
                    $('.header-text span').html(`Promo Applied: ${promo.match(/(\d+)/)[0]}% OFF Your First Box On Sign-Up!`);
                    setCookie("bonus","");
                    window.sessionStorage.setItem("bonus","");
                    setHideSweatShirt(true);
                }
            } else if(promo && promo!=="none" && bonus) {
                $('#t-header').show();
                if(bonus?.includes('sweatshirt')){
                    $('.header-text span').html(`Promo Applied: ${promo.match(/(\d+)/)[0]}% OFF First Box + FREE Sweatshirt!`);
                    setHideSweatShirt(false);
                }else {
                    $('.header-text span').html(`Promo Applied: ${promo.match(/(\d+)/)[0]}% OFF First Box + FREE Name Change Kit!`);
                }
            } else if(!planValid4Bonus  && (!promo || promo==="none")) {
                $('#t-header').hide();
                setHideSweatShirt(true);
                if(bonus?.includes('sweatshirt')){
                    setCookie("bonus","");
                    window.sessionStorage.setItem("bonus","");
                }
            }
            else {
                $('#t-header').show(); 
                if(bonus?.includes('sweatshirt')){
                    setHideSweatShirt(false);
                }
            }
        }
    },[choice, planTexts, urlParams])

    return (
        <Grid container className="subscribe-plans-container" margin="130px 0 30px" justifyContent={"center"}>
            <Grid container item xs={11} justifyContent="center">
                <img src={window.sessionStorage.getItem("promo")||getCookie("promo")||urlParams.get('promo')?require(`../../imgs/box_subs_${window.sessionStorage.getItem("promo")||getCookie("promo")||urlParams.get('promo')}.png`):require('../../imgs/box_subs.png')} alt="box" style={{maxWidth: '149px', width:"100%", marginBottom:"20px"}}></img>
                <img src={require('../../imgs/box_freeshirt.png')} alt="freeshirt" style={{display: hideSweatShirt?"none":"" ,maxWidth: '128px', width:"100%", margin:"10px 0 0 20px", maxHeight: '128px'}}></img>
                <Title title={title} description={subTitle} ></Title>
            </Grid>
            <Grid container item xs={12} sx={{opacity:ready?"1":"0"}} justifyContent="center" flexDirection={{md: hide?"column":"row", sx:"row"}} alignContent="center"  height="fit-content" spacing={(planTexts[0].show !== true)&&(isXl||isXxl)?4:2}>
                {planTexts.map((plan, index) => {
                    return(
                        <Grid key={index+1} className={hide&&index>0?"card-box hidden":"card-box"} item container xs={12} lg={3.5} xl={3} justifyContent={{xs:"center", lg:hide?"center":index===0?"flex-end":index===planTexts.length-1?"flex-start":"center"}} style={{maxWidth:isXl||isXxl?"370px":""}}>
                            <Card className={hide&&index>0?"card hidden":"card"} link="/checkout" plan={plan} onClick={()=>setChoice(index+1)} choice={choice} index={index+1} nogreyout={noGreyOut} buttononclick={()=>{
                                window.dataLayer.push({ ecommerce: null });
                                let item_id = gift? "MTM_SUB_BOX_GIFT" : "MTM_SUB_BOX_NON_GIFT";
                                let item_name = gift? "MTM Subscription Box - Gift" : "MTM Subscription Box - NonGift";
                                window.dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                    currency: "USD",
                                    value: 39.00,
                                    items: [
                                    {
                                        item_id: item_id,
                                        item_name: item_name,
                                        item_variant: plan.code,
                                        index: 0,
                                        price: 39.00,
                                        affiliation: "Miss To Mrs Box",
                                        currency: "USD",
                                        quantity: 1
                                    }
                                    ]
                                }
                                });
                            }}></Card>
                        </Grid>
                    )
                })}
            </Grid>
            <Grid container item xs={12} sx={{opacity:ready?"1":"0"}} marginTop="20px" justifyContent="center" className={hide?"":"hidden"}>
                <Link className='text-roman' sx={{borderBottom:'none!important'}} onClick={()=>{setHideShown(!hideShown)}}>{!hideShown?`SHOW ME MORE PLANS >`:`HIDE ADDITIONAL PLANS >`}</Link>
            </Grid>
            <Grid container item xs={12} sx={{opacity:ready?"1":"0"}} marginTop="20px" justifyContent="center">
                <img alt="install" src={require('../../imgs/box_subs_install.png')} width="280px"/>
            </Grid>
        </Grid>
    )
}